import { expressURL } from '../../../../../services/api'
import dayjs from 'dayjs'

export const updateInvoice = async (invoice_id, updateData) => {
  // V4 API endpoint (no /api prefix)
  const url = `${expressURL}/invoices/${invoice_id}`

  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(updateData),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return { success: true, data: response }
  } catch (error) {
    console.error('Update Error:', error)
    return { success: false, error: error.message }
  }
}

export const updateMultipleFields = async ({
  invoiceID,
  invoice_id,
  paymentStatus,
}) => {
  return await updateInvoice(invoice_id, {
    paymentStatus: paymentStatus,
    invoiceNumber: invoiceID,
  })
}

export const updateInvoiceDate = async ({ invoice_id, firstDate }) => {
  // Update the invoiceDate field (replace previous sentDate usage)
  const formatted = dayjs(firstDate).format('YYYY-MM-DD')
  return await updateInvoice(invoice_id, { invoiceDate: formatted })
}

export const setPaymentStatus = async ({ invoice_id, paymentStatus }) => {
  return await updateInvoice(invoice_id, { paymentStatus })
}

export const getLastInvoiceNumber = async (organizationId, dateObject) => {
  // V4 API endpoint (no /api prefix)
  const baseURL = `${expressURL}/invoices/lastinvoice`
  const url = `${baseURL}/${organizationId}?invocedate=${dateObject}`

  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    })

    if (!response.ok) {
      throw new Error(
        `Failed to fetch last invoice. Status: ${response.status}`
      )
    }

    const data = await response.json()
    return data // Contains: { invoiceNumber, reused }
  } catch (error) {
    console.error('Error fetching last invoice number:', error.message)
    return { invoiceNumber: null, reused: false }
  }
}

export const addSystemLog = async (logData) => {
  // V4 API endpoint (no /api prefix)
  const url = `${expressURL}/system-logs`

  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(logData),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return { success: true, data: response }
  } catch (error) {
    console.error('Log Error:', error)
    return { success: false, error: error.message }
  }
}

// Record email status for an invoice being sent to the customer
export const recordEmailStatus = async ({
  invoice_id,
  invoiceNumber,
  sentDate,
  emailSent,
}) => {
  // V4 API endpoint (no /api prefix)
  const url = `${expressURL}/invoices/email-status`
  const payload = {
    invoice_id,
    invoiceNumber,
    sentDate, // ISO string date
    emailSent, // boolean
  }

  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return { success: true, data: await response.json() }
  } catch (error) {
    console.error('Email Status Error:', error)
    return { success: false, error: error.message }
  }
}

// Update invoice with email sent status and date
export const updateInvoiceEmailStatus = async (invoice_id, emailSent, sentDate) => {
  const updateData = {
    emailSent: emailSent,
    sentDate: sentDate
  }
  
  return await updateInvoice(invoice_id, updateData)
}
